/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import * as ActionTypes from '../constants/ActionTypes';

const defaultState = {
	experimental: false,
	showImportDialog: false,
	debug: localStorage.getItem('DLDEBUG'),
	page: '/',
	errorDialog: { open: false }
};

export default function appReducer(state = defaultState, action) {
	switch (action.type) {
		case ActionTypes.SET_APP_STATE:
			return {
				...state,
				...action.newState
			};
		case 'ERROR': {
			return { ...state, error: action.payload };
		}
		default:
			return state;
	}
}
